import { Navigate, useLocation } from 'react-router-dom';

export const RedirectKeepingQuery: React.FC<{
  to: string;
  mapSearch?: (search: string) => string;
}> = ({ to, mapSearch }) => {
  const location = useLocation();
  return (
    <Navigate
      to={{
        pathname: to,
        search:
          mapSearch != null ? mapSearch(location.search) : location.search,
        hash: location.hash,
      }}
      replace
    />
  );
};
